import React from 'react'
import { Tooltip } from 'antd';
import styles from './ssnLock.module.css';
import { ISsnAuditRecord } from '../../../../../Models/applicationModels';
import { RecordType } from '../../../../../Models/tableDetailsModel';
import { UnlockedThroughSsnTitle } from './components/unlockedThroughSsnTitle/unlockedThroughSsnTitle.index';
import { IS_SSN_LOCKED_COLOR, IS_SSN_UNLOCKED_COLOR } from './ssnLockColor.constant';
import SsnKeyIcon from '../../../../Icons/ssnKey';
import { isSsnUnlocked } from '../../../../../utils/insightApplicationPage';

interface SsnLockProps {
    record: RecordType;
    selfSsnLockedDetails?: ISsnAuditRecord;
}

export const SsnLock: React.FC<SsnLockProps> = (props) => {
    const { record, selfSsnLockedDetails } = props;
    const isLocked = record.isSsnLocked;
    const isSsnUnLocked = isSsnUnlocked(record);
    const renderTitle = () => {
        if (isLocked) {
            return <p className={styles.title}>
                Identity Unlock Available 
            </p>
        }
        if (isSsnUnLocked) {
            return <UnlockedThroughSsnTitle selfSsnLockedDetails={selfSsnLockedDetails} />
        }
    }
    const title: React.ReactNode = renderTitle();

    const primaryColor: string = isLocked ? IS_SSN_LOCKED_COLOR : IS_SSN_UNLOCKED_COLOR;

    return (
        <Tooltip title={title} placement='bottomLeft' color={primaryColor}>
            <span className={styles.ssnKeyCtn}>
                <SsnKeyIcon fillColor={isLocked ? IS_SSN_LOCKED_COLOR : IS_SSN_UNLOCKED_COLOR}/>
            </span>
        </Tooltip>
    )
}
